import { Card, Text } from "@nextui-org/react"
import { useNavigate } from "react-router-dom"
import { useSelector } from "react-redux"

import { Box } from "../../../ui/layout/box"
import Button from "../../../ui/button"
import './index.css'
import { useEffect, useState } from "react"

export default ({id, name, desc, isCurrent, upcoming, data}) => {
    const navigate = useNavigate()

    const applications = useSelector(state => state.appData.applications)
    const [alreadyApplied, setAlreadyApplied] = useState(false)
    useEffect(() => {
        if (applications.length > 0) {
            for (let i = 0; i < applications.length; i++) {
                if (applications[i].opportunityId === id) {
                    setAlreadyApplied(true)
                }
            }
        }
    }, [applications])

    return (
        <>
            <Card 
                disableAnimation
                // variant="bordered"
                css={isCurrent ? {
                    // boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
                } : {}}>
                <Card.Header css={{fontWeight: "bold", display: "felx", justifyContent: "space-between", alignItems: "flex-start"}}>
                    {name}
                    {
                        isCurrent && 
                        !alreadyApplied &&
                        <Button 
                            text="Apply"
                            onClick={() => navigate(`/opportunities/apply?id=${id}`)}/>
                    }
                </Card.Header>
                <Card.Body>
                    <Text size="$sm" className="font-text">{desc}</Text>
                </Card.Body>
                <Card.Footer css={{display: "flex", flexDirection: "row", alignItems: "center", pb: "10px"}}>
                    <Box className="grantBox-label">
                        <img src={data.fund.icon} width="15px"/>
                        <Text size="$xs" as="span" css={{ml: "5px"}}>{data.fund.amount}</Text>
                    </Box>
                    <Box className="grantBox-label">
                        <img src={data.scheme.icon} width="15px"/>
                        <Text size="$xs" as="span" css={{ml: "5px"}}>{data.scheme.value}</Text>
                    </Box>
                </Card.Footer>
            </Card>
        </>
    )
}